/**
 * Lien interne : un VRAI `<a href>`, qui navigue sans recharger la page.
 *
 * Le pied de page employait des `<button>` + `navigate()`. Cela fonctionne a la
 * souris et au clavier, mais un robot d'indexation ne suit pas un bouton : il
 * ne lit que des attributs `href`. Les pages de contenu etaient donc
 * inatteignables pour Google, quand bien meme elles existaient.
 *
 * Le clic est intercepte pour garder la navigation interne (pas de rechargement,
 * pas de perte d'etat), SAUF quand le visiteur demande explicitement autre
 * chose : nouvel onglet par le milieu ou par Ctrl/Cmd, nouvelle fenetre par
 * Maj. Ces gestes doivent rester ceux du navigateur.
 */
import type { MouseEvent, ReactElement, ReactNode } from 'react';
import { navigate } from '../router.js';

export function SiteLink({
  to,
  className,
  children,
  onNavigate,
}: {
  readonly to: string;
  readonly className?: string;
  readonly children: ReactNode;
  /** Appele APRES la navigation : fermeture d'un panneau, mesure. */
  readonly onNavigate?: () => void;
}): ReactElement {
  const onClick = (event: MouseEvent<HTMLAnchorElement>): void => {
    if (event.defaultPrevented) return;
    if (event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    navigate(to);
    window.scrollTo({ top: 0 });
    onNavigate?.();
  };

  return (
    <a href={to} className={className} onClick={onClick}>
      {children}
    </a>
  );
}
